import {
  Companion_getInstance2fuogtt2v1evi as Companion_getInstance,
  asTimeZone3kdzfpoilmjbj as asTimeZone,
  asTimeZone35djf3ctanozf as asTimeZone_0,
} from './UtcOffset.mjs';
import {
  currentSystemDefaultZone332b6s6k58wi as currentSystemDefaultZone,
  timeZoneByIdov6p8ve6cmmr as timeZoneById,
  getAvailableZoneIds230racjhvglas as getAvailableZoneIds,
} from './internal/Platform.mjs';
import {
  IllegalTimeZoneException2q01rvpc2etsw as IllegalTimeZoneException,
  DateTimeFormatException2onfeknbywaob as DateTimeFormatException,
  DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException,
} from './Exceptions.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { take9j4462mea726 as take } from '../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { substring3saq8ornu0luv as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { TimeZoneSerializer_getInstance3jcki7eba0f0t as TimeZoneSerializer_getInstance } from './serializers/TimeZoneSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance68rqdv29rcfw as Companion_getInstance_0 } from './OverloadMarker.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from './LocalDateTime.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance_1 } from './LocalTime.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_2 } from '../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  dividelr0uqtdj497z as divide,
  subtract2orl8z9upxd9l as subtract,
  multiply2k9eolhnz1bjv as multiply,
  modulooi4g1kq3dmtt as modulo,
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance3h03aipe2gus4 as Companion_getInstance_3 } from './LocalDate.mjs';
import { alternativeParsing1gmwubnsvpp9b as alternativeParsing } from './format/DateTimeFormatBuilder.mjs';
import { Padding_NONE_getInstance3hrh9czbcdldi as Padding_NONE_getInstance } from './format/DateTimeFormat.mjs';
import {
  WhenToOutput_IF_NONZERO_getInstance1w5745layokcx as WhenToOutput_IF_NONZERO_getInstance,
  isoOffset2t9o0yqcdt3uh as isoOffset,
  WhenToOutput_ALWAYS_getInstancetn5gw5hc9q6 as WhenToOutput_ALWAYS_getInstance,
  Companion_instance2q34pamd1k2w7 as Companion_instance,
} from './format/UtcOffsetFormat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lenientOffsetFormat() {
  _init_properties_TimeZone_kt__dwyks9();
  return lenientOffsetFormat;
}
var lenientOffsetFormat;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.UTC_1 = FixedOffsetTimeZone().new_kotlinx_datetime_FixedOffsetTimeZone_ytfyiz_k$(Companion_getInstance().ZERO_1, 'UTC');
      }
      currentSystemDefault_9rduv_k$() {
        var _destruct__k2r9zo = currentSystemDefaultZone();
        var name = _destruct__k2r9zo.component1_7eebsc_k$();
        var zone = _destruct__k2r9zo.component2_7eebsb_k$();
        return zone == null ? this.of_5gnbr7_k$(name) : zone;
      }
      of_5gnbr7_k$(zoneId) {
        if (zoneId === 'UTC') {
          return this.UTC_1;
        }
        if (zoneId === 'Z' || zoneId === 'z') {
          return asTimeZone(Companion_getInstance().ZERO_1);
        }
        if (zoneId === 'SYSTEM') {
          return this.currentSystemDefault_9rduv_k$();
        }
        if (zoneId.length === 1) {
          throw IllegalTimeZoneException().new_kotlinx_datetime_IllegalTimeZoneException_ascxr7_k$('Invalid zone ID: ' + zoneId);
        }
        try {
          if (startsWith(zoneId, '+') || startsWith(zoneId, '-')) {
            return asTimeZone(get_lenientOffsetFormat().parse_xovy9i_k$(zoneId));
          }
          switch (zoneId) {
            case 'UTC':
            case 'GMT':
            case 'UT':
              return FixedOffsetTimeZone().new_kotlinx_datetime_FixedOffsetTimeZone_ytfyiz_k$(Companion_getInstance().ZERO_1, zoneId);
          }
          if (startsWith(zoneId, 'UTC+') || startsWith(zoneId, 'GMT+') || startsWith(zoneId, 'UTC-') || startsWith(zoneId, 'GMT-')) {
            var prefix = take(zoneId, 3);
            var offset = get_lenientOffsetFormat().parse_xovy9i_k$(substring(zoneId, 3));
            return asTimeZone_0(offset, prefix);
          }
          if (startsWith(zoneId, 'UT+') || startsWith(zoneId, 'UT-')) {
            var offset_0 = get_lenientOffsetFormat().parse_xovy9i_k$(substring(zoneId, 2));
            return asTimeZone_0(offset_0, 'UT');
          }
        } catch ($p) {
          if ($p instanceof DateTimeFormatException()) {
            var e = $p;
            throw IllegalTimeZoneException().new_kotlinx_datetime_IllegalTimeZoneException_bkml2m_k$(e);
          } else {
            throw $p;
          }
        }
        var tmp;
        try {
          tmp = timeZoneById(zoneId);
        } catch ($p_0) {
          var tmp_0;
          if ($p_0 instanceof Exception()) {
            var e_0 = $p_0;
            throw IllegalTimeZoneException().new_kotlinx_datetime_IllegalTimeZoneException_2m6qr6_k$('Invalid zone ID: ' + zoneId, e_0);
          } else {
            throw $p_0;
          }
        }
        return tmp;
      }
      get_availableZoneIds_kceyfo_k$() {
        return getAvailableZoneIds();
      }
      serializer_9w0wvi_k$() {
        return TimeZoneSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var TimeZoneClass;
function TimeZone() {
  if (TimeZoneClass === VOID) {
    class $ {
      static new_kotlinx_datetime_TimeZone_unj4p_k$() {
        Companion_getInstance_4();
        return createThis(this);
      }
      get_id_kntnx8_k$() {
        // Inline function 'kotlin.error' call
        var message = 'Should be overridden';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      atStartOfDay_893z35_k$(date) {
        // Inline function 'kotlin.error' call
        var message = 'Should be overridden';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      offsetAtImpl_umwonf_k$(instant) {
        // Inline function 'kotlin.error' call
        var message = 'Should be overridden';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      instantToLocalDateTime_3v0mft_k$(instant) {
        var tmp;
        try {
          tmp = toLocalDateTimeImpl(instant, this.offsetAtImpl_umwonf_k$(instant));
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Instant ' + instant.toString() + ' is not representable as LocalDateTime.', e);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      localDateTimeToInstant_1g6wu_k$(dateTime, preferred) {
        // Inline function 'kotlin.error' call
        var message = 'Should be overridden';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      localDateTimeToInstant$default_ot8xqs_k$(dateTime, preferred, $super) {
        preferred = preferred === VOID ? null : preferred;
        return $super === VOID ? this.localDateTimeToInstant_1g6wu_k$(dateTime, preferred) : $super.localDateTimeToInstant_1g6wu_k$.call(this, dateTime, preferred);
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof TimeZone()) {
            tmp_0 = this.get_id_kntnx8_k$() === other.get_id_kntnx8_k$();
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.get_id_kntnx8_k$());
      }
      toString() {
        return this.get_id_kntnx8_k$();
      }
    }
    initMetadataForClass($, 'TimeZone');
    TimeZoneClass = $;
  }
  return TimeZoneClass;
}
function toLocalDateTime(_this__u8e3s4, timeZone) {
  _init_properties_TimeZone_kt__dwyks9();
  return timeZone.instantToLocalDateTime_3v0mft_k$(_this__u8e3s4);
}
function toInstant(_this__u8e3s4, timeZone, youShallNotPass) {
  youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_0().INSTANCE_1 : youShallNotPass;
  _init_properties_TimeZone_kt__dwyks9();
  return timeZone.localDateTimeToInstant$default_ot8xqs_k$(_this__u8e3s4);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
var FixedOffsetTimeZoneClass;
function FixedOffsetTimeZone() {
  if (FixedOffsetTimeZoneClass === VOID) {
    class $ extends TimeZone() {
      constructor(offset, id) {
        return new.target.new_kotlinx_datetime_FixedOffsetTimeZone_ytfyiz_k$(offset, id);
      }
      static new_kotlinx_datetime_FixedOffsetTimeZone_ytfyiz_k$(offset, id) {
        var $this = this.new_kotlinx_datetime_TimeZone_unj4p_k$();
        $this.offset_1 = offset;
        $this.id_1 = id;
        return $this;
      }
      get_id_kntnx8_k$() {
        return this.id_1;
      }
      static new_kotlinx_datetime_FixedOffsetTimeZone_pnfpw_k$(offset) {
        return this.new_kotlinx_datetime_FixedOffsetTimeZone_ytfyiz_k$(offset, offset.toString());
      }
      atStartOfDay_893z35_k$(date) {
        return toInstant_0(LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(date, Companion_getInstance_1().MIN_1), this.offset_1);
      }
      offsetAtImpl_umwonf_k$(instant) {
        return this.offset_1;
      }
      localDateTimeToInstant_1g6wu_k$(dateTime, preferred) {
        return toInstant_0(dateTime, this.offset_1);
      }
      instantToLocalDateTime_3v0mft_k$(instant) {
        return toLocalDateTime_0(instant, this.offset_1);
      }
    }
    initMetadataForClass($, 'FixedOffsetTimeZone');
    FixedOffsetTimeZoneClass = $;
  }
  return FixedOffsetTimeZoneClass;
}
function offsetAt(_this__u8e3s4, instant) {
  _init_properties_TimeZone_kt__dwyks9();
  return _this__u8e3s4.offsetAtImpl_umwonf_k$(instant);
}
function toInstant_0(_this__u8e3s4, offset, youShallNotPass) {
  youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_0().INSTANCE_1 : youShallNotPass;
  _init_properties_TimeZone_kt__dwyks9();
  return Companion_getInstance_2().fromEpochSeconds_w2e12k_k$(_this__u8e3s4.toEpochSecond_e9u42_k$(offset), _this__u8e3s4.get_nanosecond_fws9td_k$());
}
function toLocalDateTime_0(_this__u8e3s4, offset) {
  _init_properties_TimeZone_kt__dwyks9();
  var tmp;
  try {
    tmp = toLocalDateTimeImpl(_this__u8e3s4, offset);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof IllegalArgumentException()) {
      var e = $p;
      throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Instant ' + _this__u8e3s4.toString() + ' is not representable as LocalDateTime', e);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function toLocalDateTimeImpl(_this__u8e3s4, offset) {
  _init_properties_TimeZone_kt__dwyks9();
  var tmp0 = _this__u8e3s4.epochSeconds_1;
  // Inline function 'kotlin.Long.plus' call
  var other = offset.totalSeconds_1;
  var localSecond = add(tmp0, fromInt(other));
  // Inline function 'kotlin.floorDiv' call
  var q = divide(localSecond, 86400n);
  if ((localSecond ^ 86400n) < 0n && !(multiply(q, 86400n) === localSecond)) {
    var _unary__edvuaz = q;
    q = subtract(_unary__edvuaz, get_ONE());
  }
  var localEpochDay = q;
  // Inline function 'kotlin.mod' call
  var r = modulo(localSecond, 86400n);
  var tmp$ret$2 = add(r, 86400n & shiftRight((r ^ 86400n) & (r | negate(r)), 63));
  var secsOfDay = convertToInt(tmp$ret$2);
  var date = Companion_getInstance_3().fromEpochDays_a3paq6_k$(localEpochDay);
  var time = Companion_getInstance_1().ofSecondOfDay_9u5rnn_k$(secsOfDay, _this__u8e3s4.nanosecondsOfSecond_1);
  return LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(date, time);
}
function atStartOfDayIn(_this__u8e3s4, timeZone, youShallNotPass) {
  youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_0().INSTANCE_1 : youShallNotPass;
  _init_properties_TimeZone_kt__dwyks9();
  return timeZone.atStartOfDay_893z35_k$(_this__u8e3s4);
}
function lenientOffsetFormat$lambda($this$build) {
  _init_properties_TimeZone_kt__dwyks9();
  var tmp = lenientOffsetFormat$lambda$lambda;
  var tmp_0 = [tmp, lenientOffsetFormat$lambda$lambda_0];
  alternativeParsing($this$build, tmp_0, lenientOffsetFormat$lambda$lambda_1);
  return Unit_instance;
}
function lenientOffsetFormat$lambda$lambda($this$alternativeParsing) {
  _init_properties_TimeZone_kt__dwyks9();
  $this$alternativeParsing.offsetHours_tq5sq0_k$(Padding_NONE_getInstance());
  return Unit_instance;
}
function lenientOffsetFormat$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_TimeZone_kt__dwyks9();
  isoOffset($this$alternativeParsing, false, false, WhenToOutput_IF_NONZERO_getInstance(), WhenToOutput_IF_NONZERO_getInstance());
  return Unit_instance;
}
function lenientOffsetFormat$lambda$lambda_1($this$alternativeParsing) {
  _init_properties_TimeZone_kt__dwyks9();
  isoOffset($this$alternativeParsing, true, true, WhenToOutput_ALWAYS_getInstance(), WhenToOutput_IF_NONZERO_getInstance());
  return Unit_instance;
}
var properties_initialized_TimeZone_kt_fgsidh;
function _init_properties_TimeZone_kt__dwyks9() {
  if (!properties_initialized_TimeZone_kt_fgsidh) {
    properties_initialized_TimeZone_kt_fgsidh = true;
    var tmp = Companion_instance;
    lenientOffsetFormat = tmp.build_dzztnl_k$(lenientOffsetFormat$lambda);
  }
}
//region block: init
Companion_instance_1 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance_4 as Companion_getInstance13ujfby7pfhe7,
  FixedOffsetTimeZone as FixedOffsetTimeZone3oldrgkltiv4z,
  TimeZone as TimeZone3oibfp0mqo4lg,
  atStartOfDayIn as atStartOfDayInq85k5urxn794,
  offsetAt as offsetAt16yxz78htuv90,
  toInstant as toInstant2ixtmlbww6j32,
  toInstant_0 as toInstant1fmt1re8uidf7,
  toLocalDateTime as toLocalDateTime2fafgh396r2y5,
  toLocalDateTime_0 as toLocalDateTime1cof646mhw5l9,
};
//endregion

//# sourceMappingURL=TimeZone.mjs.map
